{
  "de": {
    "join": {
      "heading": "Willkommen bei fobizz",
      "paragraph": "Aktiviere den Zugang zu deiner Lizenzgruppe. Du erhältst den Code von der Ansprechperson an deiner Bildungseinrichtung.",
      "button": "Aktivieren",
      "back": "Zur Startseite",
      "autoSubmitting": "Lizenz wird aktiviert …"
    }
  }
}
